(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3739],{

/***/ 42903:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[slug]",
      function () {
        return __webpack_require__(56588);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/platform/views/Auth/SignUp.jsx + 1 modules
var SignUp = __webpack_require__(8338);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Clearco.svg
var Clearco = __webpack_require__(8869);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Openly.svg
var Openly = __webpack_require__(68197);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers.svg
var Farmers = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered.svg
var StandardChartered = __webpack_require__(86051);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz.svg
var Anz = __webpack_require__(33911);
// EXTERNAL MODULE: ./src/landingPage/views/LandingTemplate/components/LandingCtas.jsx
var LandingCtas = __webpack_require__(93022);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
// EXTERNAL MODULE: ./src/platform/components/Loader/Loader.jsx
var Loader = __webpack_require__(5786);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./src/platform/views/Auth/components/AuthPagePaper.jsx
var AuthPagePaper = __webpack_require__(55474);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/input_field/index.jsx
var input_field = __webpack_require__(71493);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/textarea_field/index.jsx + 2 modules
var textarea_field = __webpack_require__(58733);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/button/index.jsx
var ui_button = __webpack_require__(58278);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/checkbox_field/index.jsx + 9 modules
var checkbox_field = __webpack_require__(31993);
// EXTERNAL MODULE: ./src/landingPage/utils/form-functions.js
var form_functions = __webpack_require__(67534);
// EXTERNAL MODULE: ./src/utils/formAttribution.js
var formAttribution = __webpack_require__(64357);
// EXTERNAL MODULE: ./src/api/userApi.js
var userApi = __webpack_require__(62725);
;// CONCATENATED MODULE: ./src/landingPage/views/LandingTemplate/components/LandingContactForm.jsx




















var LandingContactForm = function(param) {
    var data = param.data;
    var contactFormData = {
        fields: [
            {
                label: "Full name",
                id: "full_name",
                type: "text",
                component: "input",
                required: true
            },
            {
                label: "Business Email",
                id: "email",
                type: "email",
                component: "input",
                required: true
            },
            {
                label: "Company",
                id: "company",
                type: "text",
                component: "input",
                required: true
            },
            {
                label: "Role",
                id: "role",
                type: "text",
                component: "input",
                required: false
            },
            {
                label: "How can Demyst help you?",
                id: "message",
                component: "textarea",
                required: false
            }, 
        ],
        errors: {
            field_required: "This field is required!",
            incorrect_mail: "This email address is incorrect."
        }
    };
    var handleContactFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var dataToSend;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!((0,form_functions/* validate */.G)({
                            type: "contact",
                            formData: formData,
                            data: contactFormData,
                            changeErrors: changeErrors,
                            consent: consent
                        }) === true)) {
                            _ctx.next = 15;
                            break;
                        }
                        changeSending(true);
                        dataToSend = {
                            type: "contact",
                            formValues: preparedData()
                        };
                        (0,userTracking/* sendGaEvent */.k8)({
                            action: "Form Submission",
                            category: "Contact"
                        }, formData.email);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return userApi/* userApi.sendFrontForm */.B.sendFrontForm(dataToSend);
                    case 8:
                        changeSending(false);
                        changeContactFormSent(true);
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](5);
                        changeSending(false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    12
                ]
            ]);
        }));
        return function handleContactFormSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref = (0,react.useState)(false), consent = ref[0], changeConsent = ref[1];
    var ref1 = (0,react.useState)({}), formData = ref1[0], changeFormData = ref1[1];
    var ref2 = (0,react.useState)({}), errors = ref2[0], changeErrors = ref2[1];
    var ref3 = (0,react.useState)(false), sending = ref3[0], changeSending = ref3[1];
    var ref4 = (0,react.useState)(false), contactFormSent = ref4[0], changeContactFormSent = ref4[1];
    var termsConditionsLabel = /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        children: [
            "I agree to Demyst's ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: linksConstants/* linksConstants.PRIVACY */.s.PRIVACY,
                target: "_blank",
                rel: "noreferrer",
                children: "Privacy Policy"
            }),
            " and ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: linksConstants/* linksConstants.TERMS */.s.TERMS,
                target: "_blank",
                rel: "noreferrer",
                children: "Terms and Conditions"
            }),
            "."
        ]
    });
    var changeData = function(e, data) {
        var newFormData = (0,_object_spread/* default */.Z)({}, formData);
        newFormData[data.id] = e;
        changeFormData(newFormData);
    };
    var preparedData = function() {
        var preparedData = (0,formAttribution/* formAttribution */.e)("Contact Form");
        contactFormData.fields.forEach(function(field) {
            preparedData[field.id] = formData[field.id];
        });
        return preparedData;
    };
    (0,react.useEffect)(function() {
        var newFormData = {};
        contactFormData.fields.forEach(function(field) {
            newFormData[field.id] = "";
        });
        changeFormData(newFormData);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("SignUp__paper", "LandingHero-form"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthPagePaper/* AuthPagePaper */.v, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                    className: "SignUp__paper__header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "SignUp__paper__header__title",
                        children: contactFormSent ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: data.form_sent_title || "Submission successful"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: data.form_title || "Contact us"
                        })
                    })
                }),
                contactFormSent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "SignUp__paper__header__message",
                    children: data.form_sent_message ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: data.form_sent_message
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Thanks for reaching out. We will be in touch soon."
                        })
                    })
                }),
                !contactFormSent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleContactFormSubmit,
                    className: "SignUpForm ContactForm",
                    children: [
                        contactFormData.fields.map(function(field, fieldIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "SignUpForm__textfieldWrapper",
                                children: [
                                    field.component === "input" && /*#__PURE__*/ (0,jsx_runtime.jsx)(input_field/* default */.Z, {
                                        size: "regular",
                                        name: field.id,
                                        label: field.label,
                                        id: field.id,
                                        value: formData[field.id],
                                        error: errors[field.id],
                                        onChange: function(e) {
                                            return changeData(e, field);
                                        },
                                        showRequiredAsterisk: false,
                                        required: field.required
                                    }),
                                    field.component === "textarea" && /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_field/* default */.Z, {
                                        size: "regular",
                                        value: formData[field.id],
                                        label: field.label,
                                        onChange: function(e) {
                                            return changeData(e, field);
                                        },
                                        error: errors[field.id],
                                        required: field.required,
                                        showRequiredAsterisk: false
                                    })
                                ]
                            }, fieldIndex);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_field/* default */.Z, {
                            label: termsConditionsLabel,
                            name: "acceptTerms",
                            id: "acceptTerms",
                            size: "regular",
                            onChange: changeConsent,
                            error: errors.consent,
                            checkex: consent,
                            required: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                            type: "submit",
                            size: "large",
                            fullWidth: true,
                            demystIcon: true,
                            variant: "secondary",
                            children: "Submit"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                    children: sending && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: "SignUp__paper__loadingOverlay"
                    }, appConfig/* animatePresenceConfig */.Rr), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
                    }))
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/LandingTemplate/components/LandingHero.jsx










var LandingHero = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,clsx_m/* default */.Z)("LandingHero-background", data.background_color && "LandingHero-background-".concat(data.background_color), data.background_gradient && "LandingHero-background-gradient"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("LandingHero", data.type && "LandingHero-type-".concat(data.type), data.background_color && "LandingHero-".concat(data.background_color), data.align && "LandingHero-align-".concat(data.align)),
            id: "hero",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "section-layout",
                    children: [
                        data.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "LandingHero-title",
                            children: data.headline
                        }),
                        data.subheadline && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "LandingHero-subtitle",
                            children: data.subheadline
                        }),
                        data.show_image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "LandingHero-image",
                            src: data.image,
                            alt: data.image_alt,
                            loading: "eager"
                        }),
                        data.type === "cta" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCtas/* LandingCtas */.f, {
                            ctas: data === null || data === void 0 ? void 0 : data.ctas
                        }),
                        data.show_logos && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "LandingHero-logos",
                            children: [
                                data.logos_headline && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: data.logos_headline
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "LandingHero-logos-images",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: Farmers/* default.src */.Z.src,
                                            alt: "Farmers Insurance",
                                            loading: "eager",
                                            width: "82",
                                            height: "44"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: Anz/* default.src */.Z.src,
                                            alt: "ANZ",
                                            loading: "eager",
                                            width: "96",
                                            height: "31"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: StandardChartered/* default.src */.Z.src,
                                            alt: "Standard Chartered",
                                            loading: "eager",
                                            width: "111",
                                            height: "45"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: Openly/* default.src */.Z.src,
                                            alt: "Openly",
                                            loading: "eager",
                                            width: "71",
                                            height: "45"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: Clearco/* default.src */.Z.src,
                                            alt: "Clearco (formerly Clearbank)",
                                            loading: "eager",
                                            width: "119",
                                            height: "25"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                data.type === "platform-sign-up" && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "section-layout",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUp/* SignUpForm */.W, {
                        className: "LandingHero-form",
                        showLogInLink: false,
                        titleOverride: data.form_title,
                        sentTitleOverride: data.form_sent_title,
                        sentMessageOverride: data.form_sent_message
                    })
                }),
                data.type === "contact-form" && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "section-layout",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingContactForm, {
                        data: data
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/landingPage/views/LandingTemplate/components/LandingTestimonials.jsx








var LandingTestimonials = function(param) {
    var testimonials = param.testimonials;
    var card = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), activeIndex = ref[0], setActiveIndex = ref[1];
    var goToNextCard = function(i) {
        var nextIndex = i + 1;
        if (nextIndex >= testimonials.length) nextIndex = 0;
        setActiveIndex(nextIndex);
    };
    var goToPrevCard = function(i) {
        var prevIndex = i - 1;
        if (prevIndex < 0) prevIndex = testimonials.length - 1;
        setActiveIndex(prevIndex);
    };
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            goToNextCard(activeIndex);
        }, 10000);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        activeIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "section-layout",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "LandingTestimonials",
            children: testimonials.map(function(testimonial, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: index === activeIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appConfig/* animatePresenceConfig */.Rr), {
                            transition: {
                                duration: 1.0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("LandingTestimonials-testimonial", "index-".concat(index)),
                                ref: card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "LandingTestimonials-testimonial-content",
                                        children: [
                                            (testimonial === null || testimonial === void 0 ? void 0 : testimonial.quote) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: "“".concat(testimonial === null || testimonial === void 0 ? void 0 : testimonial.quote.trim(), "”")
                                            }),
                                            (testimonial === null || testimonial === void 0 ? void 0 : testimonial.author_name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "— ",
                                                    testimonial === null || testimonial === void 0 ? void 0 : testimonial.author_name
                                                ]
                                            }),
                                            (testimonial === null || testimonial === void 0 ? void 0 : testimonial.author_title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: testimonial === null || testimonial === void 0 ? void 0 : testimonial.author_title
                                            }),
                                            testimonials.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "LandingTestimonials-testimonial-toggles",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        "aria-label": "Previous testimonial",
                                                        onClick: function() {
                                                            goToPrevCard(activeIndex);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiArrowLeft */.Ao2, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        "aria-label": "Next testimonial",
                                                        onClick: function() {
                                                            goToNextCard(activeIndex);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiArrowRight */.Rgz, {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (testimonial === null || testimonial === void 0 ? void 0 : testimonial.show_image) && (testimonial === null || testimonial === void 0 ? void 0 : testimonial.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "LandingTestimonials-testimonial-image",
                                        style: {
                                            backgroundImage: "url(".concat(testimonial === null || testimonial === void 0 ? void 0 : testimonial.image)
                                        },
                                        "aria-label": testimonial === null || testimonial === void 0 ? void 0 : testimonial.image_alt
                                    })
                                ]
                            }, index)
                        }))
                    })
                });
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/LandingTemplate/components/LandingImageBar.jsx


var LandingImageBar = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "section-layout",
        children: (data === null || data === void 0 ? void 0 : (ref = data.fields) === null || ref === void 0 ? void 0 : ref.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: data === null || data === void 0 ? void 0 : (ref1 = data.fields) === null || ref1 === void 0 ? void 0 : ref1.image,
            alt: data === null || data === void 0 ? void 0 : (ref2 = data.fields) === null || ref2 === void 0 ? void 0 : ref2.image_alt,
            className: (0,clsx_m/* default */.Z)("LandingImageBar", (data === null || data === void 0 ? void 0 : (ref3 = data.fields) === null || ref3 === void 0 ? void 0 : ref3.remove_border_radius) === true && "no-radius")
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/LandingTemplate/components/LandingTextImageContent.jsx



var LandingTextImageContent = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)("section-layout", (data === null || data === void 0 ? void 0 : (ref = data.fields) === null || ref === void 0 ? void 0 : ref.text_position) === "center" && "section-layout-column"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("LandingTextImageContent-col", "LandingTextImageContent-col-text", (data === null || data === void 0 ? void 0 : (ref1 = data.fields) === null || ref1 === void 0 ? void 0 : ref1.text_position) && "LandingTextImageContent-col-text-position-".concat(data === null || data === void 0 ? void 0 : (ref2 = data.fields) === null || ref2 === void 0 ? void 0 : ref2.text_position)),
                children: [
                    (data === null || data === void 0 ? void 0 : (ref3 = data.fields) === null || ref3 === void 0 ? void 0 : ref3.headline) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: data === null || data === void 0 ? void 0 : (ref4 = data.fields) === null || ref4 === void 0 ? void 0 : ref4.headline
                    }),
                    (data === null || data === void 0 ? void 0 : (ref5 = data.fields) === null || ref5 === void 0 ? void 0 : ref5.subheadline) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: data === null || data === void 0 ? void 0 : (ref6 = data.fields) === null || ref6 === void 0 ? void 0 : ref6.subheadline
                    }),
                    (data === null || data === void 0 ? void 0 : (ref7 = data.fields) === null || ref7 === void 0 ? void 0 : ref7.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "LandingTextImageContent-dangerous-content",
                        dangerouslySetInnerHTML: {
                            __html: data === null || data === void 0 ? void 0 : (ref8 = data.fields) === null || ref8 === void 0 ? void 0 : ref8.content
                        }
                    }),
                    (data === null || data === void 0 ? void 0 : (ref9 = data.fields) === null || ref9 === void 0 ? void 0 : ref9.ctas) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCtas/* LandingCtas */.f, {
                        ctas: data === null || data === void 0 ? void 0 : (ref10 = data.fields) === null || ref10 === void 0 ? void 0 : ref10.ctas
                    })
                ]
            }),
            (data === null || data === void 0 ? void 0 : (ref11 = data.fields) === null || ref11 === void 0 ? void 0 : ref11.show_image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "LandingTextImageContent-col",
                children: (data === null || data === void 0 ? void 0 : (ref12 = data.fields) === null || ref12 === void 0 ? void 0 : ref12.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: data === null || data === void 0 ? void 0 : (ref13 = data.fields) === null || ref13 === void 0 ? void 0 : ref13.image.src,
                    alt: data === null || data === void 0 ? void 0 : (ref14 = data.fields) === null || ref14 === void 0 ? void 0 : ref14.image_alt
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/views/LandingTemplate/components/LandingCustomers.jsx
var LandingCustomers = __webpack_require__(59666);
// EXTERNAL MODULE: ./src/landingPage/views/LandingTemplate/components/LandingButterLink.jsx
var LandingButterLink = __webpack_require__(49570);
;// CONCATENATED MODULE: ./src/landingPage/views/LandingTemplate/components/LandingButtonGrid.jsx



var LandingButtonGrid = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "section-layout",
        children: [
            (data === null || data === void 0 ? void 0 : (ref = data.fields) === null || ref === void 0 ? void 0 : ref.headline) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: data === null || data === void 0 ? void 0 : (ref1 = data.fields) === null || ref1 === void 0 ? void 0 : ref1.headline
            }),
            (data === null || data === void 0 ? void 0 : (ref2 = data.fields) === null || ref2 === void 0 ? void 0 : ref2.subheadline) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: data === null || data === void 0 ? void 0 : (ref3 = data.fields) === null || ref3 === void 0 ? void 0 : ref3.subheadline
            }),
            (data === null || data === void 0 ? void 0 : (ref4 = data.fields) === null || ref4 === void 0 ? void 0 : ref4.buttons) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("LandingButtonGrid", (data === null || data === void 0 ? void 0 : (ref5 = data.fields) === null || ref5 === void 0 ? void 0 : ref5.buttons_color) && "LandingButtonGrid-".concat(data === null || data === void 0 ? void 0 : (ref6 = data.fields) === null || ref6 === void 0 ? void 0 : ref6.buttons_color)),
                children: data === null || data === void 0 ? void 0 : (ref7 = data.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.buttons) === null || ref8 === void 0 ? void 0 : ref8.map(function(button) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(LandingButterLink/* LandingButterLink */.v, {
                        noStyle: true,
                        url: button === null || button === void 0 ? void 0 : button.button_url,
                        children: [
                            (button === null || button === void 0 ? void 0 : button.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: button === null || button === void 0 ? void 0 : button.image,
                                alt: button === null || button === void 0 ? void 0 : button.image_alt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    (button === null || button === void 0 ? void 0 : button.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "LandingButtonGrid-title",
                                        children: button === null || button === void 0 ? void 0 : button.title
                                    }),
                                    (button === null || button === void 0 ? void 0 : button.subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "LandingButtonGrid-subtitle",
                                        children: button === null || button === void 0 ? void 0 : button.subtitle
                                    })
                                ]
                            })
                        ]
                    }, button);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/LandingTemplate/components/LandingCtaBar.jsx



var LandingCtaBar = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "section-layout",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("LandingCtaBar", (data === null || data === void 0 ? void 0 : (ref = data.fields) === null || ref === void 0 ? void 0 : ref.button_align) && "LandingCtaBar-align-".concat(data === null || data === void 0 ? void 0 : (ref1 = data.fields) === null || ref1 === void 0 ? void 0 : ref1.button_align)),
            children: [
                (data === null || data === void 0 ? void 0 : (ref2 = data.fields) === null || ref2 === void 0 ? void 0 : ref2.label) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: data === null || data === void 0 ? void 0 : (ref3 = data.fields) === null || ref3 === void 0 ? void 0 : ref3.label
                }),
                (data === null || data === void 0 ? void 0 : (ref4 = data.fields) === null || ref4 === void 0 ? void 0 : ref4.ctas) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCtas/* LandingCtas */.f, {
                    ctas: data === null || data === void 0 ? void 0 : (ref5 = data.fields) === null || ref5 === void 0 ? void 0 : ref5.ctas
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/LandingTemplate/components/LandingMainContent.jsx








var LandingMainContent = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data.map(function(component, componentIndex) {
            var ref, ref1, ref2, ref3, ref4;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("LandingMainContent", "LandingMainContent-".concat(component.type), ((ref = component.fields) === null || ref === void 0 ? void 0 : ref.background_color) && "LandingMainContent-background-".concat((ref1 = component.fields) === null || ref1 === void 0 ? void 0 : ref1.background_color), ((ref2 = component.fields) === null || ref2 === void 0 ? void 0 : ref2.align) && "LandingMainContent-align-".concat((ref3 = component.fields) === null || ref3 === void 0 ? void 0 : ref3.align)),
                id: "main_".concat(componentIndex + 1),
                children: [
                    component.type === "customers" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCustomers/* LandingCustomers */.l, {
                        data: component
                    }),
                    component.type === "text_image" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingTextImageContent, {
                        data: component
                    }),
                    component.type === "button_grid" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingButtonGrid, {
                        data: component
                    }),
                    component.type === "image_bar" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingImageBar, {
                        data: component
                    }),
                    component.type === "cta_bar" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCtaBar, {
                        data: component
                    }),
                    component.type === "testimonials" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingTestimonials, {
                        testimonials: component === null || component === void 0 ? void 0 : (ref4 = component.fields) === null || ref4 === void 0 ? void 0 : ref4.testimonials
                    })
                ]
            }, componentIndex);
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/LandingTemplate/LandingTemplate.jsx



var LandingTemplate = function(param) {
    var heroData = param.heroData, mainData = param.mainData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            heroData && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingHero, {
                data: heroData
            }),
            mainData && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingMainContent, {
                data: mainData
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/info/[slug].jsx



var WebinarRegistrationPage = function(param) {
    var heroData = param.heroData, mainData = param.mainData, meta = param.meta, resolvedUrl = param.resolvedUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: resolvedUrl,
                title: meta === null || meta === void 0 ? void 0 : meta.title,
                description: meta === null || meta === void 0 ? void 0 : meta.description,
                pageImageUrl: meta === null || meta === void 0 ? void 0 : meta.image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingTemplate, {
                heroData: heroData,
                mainData: mainData
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (WebinarRegistrationPage);


/***/ }),

/***/ 86713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ formComponent; }
/* harmony export */ });
var formComponent = {
    button_text: "Submit",
    errors: {
        field_required: "This field is required!",
        incorrect_mail: "This email address is incorrect."
    },
    form: {
        consent: {
            beginning: "I agree to ",
            link1_text: "Terms and Conditions",
            link1_url: "/terms-and-conditions",
            separator: " and ",
            link2_text: "Privacy Policy",
            link2_url: "/privacy-policy"
        },
        button_text: "Submit"
    }
};


/***/ }),

/***/ 67534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ validate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86713);


var flattenDataArray = function(data) {
    var newData = {
        fields: []
    };
    data.fields.forEach(function(field) {
        if (field.component !== "standard-multielement") {
            newData.fields.push(field);
        } else {
            var _fields;
            (_fields = newData.fields).push.apply(_fields, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(field.fields));
        }
    });
    return newData;
};
var validate = function(param) {
    var type = param.type, formData = param.formData, data = param.data, changeErrors = param.changeErrors, consent = param.consent;
    var newErrors = setErrors({
        type: type,
        formData: formData,
        data: flattenDataArray(data),
        consent: consent
    });
    changeErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
        return true;
    } else {
        scrollToError(newErrors);
        return false;
    }
};
var setErrors = function(param) {
    var type = param.type, formData = param.formData, data = param.data, consent = param.consent;
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var newErrors = {};
    if (type === "DSAR" && formData.is_data_subject !== data.fields.filter(function(field) {
        return field.id === "is_data_subject";
    })[0].options[1]) {
        data.fields.filter(function(field) {
            return field.required === true && field.id.substring(0, 8).indexOf("detail_") === -1;
        }).forEach(function(field) {
            if (formData[field.id].length === 0) newErrors[field.id] = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.field_required */ .j.errors.field_required;
            if (formData.email.length !== 0 && !regex.test(String(formData.email).toLowerCase())) newErrors.email = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.incorrect_mail */ .j.errors.incorrect_mail;
        });
    } else {
        data.fields.filter(function(field) {
            return field.required === true;
        }).forEach(function(field) {
            var ref, ref1;
            if (formData[field.id].length === 0) newErrors[field.id] = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.field_required */ .j.errors.field_required;
            if (typeof formData.email !== "undefined" && ((ref = formData.email) === null || ref === void 0 ? void 0 : ref.length) !== 0 && !regex.test(String(formData.email).toLowerCase())) newErrors.email = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.incorrect_mail */ .j.errors.incorrect_mail;
            if (typeof formData.email_bottom !== "undefined" && ((ref1 = formData.email_bottom) === null || ref1 === void 0 ? void 0 : ref1.length) !== 0 && !regex.test(String(formData.email_bottom).toLowerCase())) newErrors.email_bottom = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.incorrect_mail */ .j.errors.incorrect_mail;
        });
    }
    if (typeof consent !== "undefined" && consent === false) newErrors.consent = _datasets_formComponent__WEBPACK_IMPORTED_MODULE_0__/* .formComponent.errors.field_required */ .j.errors.field_required;
    return newErrors;
};
var scrollToError = function(errorsObject) {
    var _Math;
    var errorLabels = [];
    errorLabels = Object.keys(errorsObject);
    var scrollTop = window.pageYOffset;
    var positions = [];
    errorLabels.forEach(function(label) {
        var element = document.getElementById("standard-".concat(label));
        if (typeof element === "undefined") element = document.getElementById("retractible-".concat(label));
        if (label === "consent") element = document.getElementById("consent");
        var rect = element.getBoundingClientRect();
        var position = rect.top;
        positions.push(position);
    });
    window.scroll({
        top: (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(positions)) + scrollTop - 170,
        left: 0,
        behavior: "smooth"
    });
};


/***/ }),

/***/ 49570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ LandingButterLink; }
/* harmony export */ });
/* unused harmony export onLandingButterLinkClick */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _config_userTracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67474);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_LinkButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84135);







var onLandingButterLinkClick = function(e, pathname, section) {
    var target = e === null || e === void 0 ? void 0 : e.target;
    (0,_config_userTracking__WEBPACK_IMPORTED_MODULE_1__/* .sendGaEvent */ .k8)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        action: "Button Click",
        category: "SEO"
    }, target && {
        label: "".concat(target === null || target === void 0 ? void 0 : target.innerText.slice(0, 10), " - ").concat(section ? "".concat(section.slice(0, 10), " - ") : " ").concat(pathname)
    }));
    return false;
};
var LandingButterLink = function(param) {
    var url = param.url, className = param.className, _external = param.external, external = _external === void 0 ? false : _external, section = param.section, children = param.children, demystIcon = param.demystIcon, variant = param.variant, size = param.size, onClick = param.onClick, _noStyle = param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, mainCTA = param.mainCTA;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var pathname = router.asPath;
    var sanitizeButterUrl = function(url) {
        var isValidHttpUrl = function(string) {
            var jsUrl;
            try {
                jsUrl = new URL(string);
            } catch (e) {
                return false;
            }
            return jsUrl.protocol === "http:" || jsUrl.protocol === "https:";
        };
        if (isValidHttpUrl(url)) return {
            target: "_blank",
            rel: "noreferrer noopener",
            to: new URL(url)
        };
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            to: url.endsWith("/") ? url.slice(0, -1) : url
        }, external === true && {
            isExternal: true
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LinkButton__WEBPACK_IMPORTED_MODULE_3__/* .LinkButton */ .Q, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sanitizeButterUrl(url)), {
        className: className,
        onClick: function(event) {
            onLandingButterLinkClick(event, pathname, section);
            (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(onClick, Function) && onClick();
        },
        demystIcon: demystIcon,
        size: size,
        variant: variant,
        noStyle: noStyle,
        mainCTA: mainCTA,
        children: children
    }));
};


/***/ }),

/***/ 93022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LandingCtas; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var _LandingButterLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49570);



var LandingCtas = function(param) {
    var ctas = param.ctas;
    if (!ctas) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "LandingCtas",
        children: ctas === null || ctas === void 0 ? void 0 : ctas.map(function(cta) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingButterLink__WEBPACK_IMPORTED_MODULE_1__/* .LandingButterLink */ .v, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("LandingCtas-button", (cta === null || cta === void 0 ? void 0 : cta.button_variant) && "LandingCtas-button-".concat(cta === null || cta === void 0 ? void 0 : cta.button_variant)),
                variant: cta === null || cta === void 0 ? void 0 : cta.button_variant,
                demystIcon: (cta === null || cta === void 0 ? void 0 : cta.show_button_logo) === true,
                url: cta === null || cta === void 0 ? void 0 : cta.button_url,
                section: cta === null || cta === void 0 ? void 0 : cta.section,
                size: cta === null || cta === void 0 ? void 0 : cta.button_size,
                onClick: cta === null || cta === void 0 ? void 0 : cta.onClick,
                mainCTA: cta === null || cta === void 0 ? void 0 : cta.mainCTA,
                children: cta === null || cta === void 0 ? void 0 : cta.button_label
            }, cta);
        })
    });
};


/***/ }),

/***/ 59666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ LandingCustomers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _LandingCtas__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93022);


var LandingCustomers = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "section-layout",
        children: [
            (data === null || data === void 0 ? void 0 : (ref = data.fields) === null || ref === void 0 ? void 0 : ref.headline) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: data === null || data === void 0 ? void 0 : (ref1 = data.fields) === null || ref1 === void 0 ? void 0 : ref1.headline
            }),
            (data === null || data === void 0 ? void 0 : (ref2 = data.fields) === null || ref2 === void 0 ? void 0 : ref2.subheadline) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: data === null || data === void 0 ? void 0 : (ref3 = data.fields) === null || ref3 === void 0 ? void 0 : ref3.subheadline
            }),
            (data === null || data === void 0 ? void 0 : (ref4 = data.fields) === null || ref4 === void 0 ? void 0 : ref4.logos) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "LandingCustomers",
                children: data === null || data === void 0 ? void 0 : (ref5 = data.fields) === null || ref5 === void 0 ? void 0 : ref5.logos.map(function(logo) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: logo.image,
                        alt: logo.image_alt,
                        loading: "lazy"
                    }, logo);
                })
            }),
            (data === null || data === void 0 ? void 0 : (ref6 = data.fields) === null || ref6 === void 0 ? void 0 : ref6.ctas) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingCtas__WEBPACK_IMPORTED_MODULE_1__/* .LandingCtas */ .f, {
                ctas: data === null || data === void 0 ? void 0 : (ref7 = data.fields) === null || ref7 === void 0 ? void 0 : ref7.ctas
            })
        ]
    });
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        }
    }, isExternal && {
        target: "_blank",
        rel: "noreferrer"
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 58733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextareaField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@reach/auto-id/dist/reach-auto-id.esm.js
var reach_auto_id_esm = __webpack_require__(765);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/field/index.jsx + 1 modules
var field = __webpack_require__(33076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(70714);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/input/index.styles.js + 1 modules
var index_styles = __webpack_require__(56455);
;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/textarea/index.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  line-height: 1.2;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Textarea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
    componentId: "sc-20bec303-0"
})(_templateObject(), index_styles/* inputStyles */.TL);

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/textarea/index.jsx







/**
 * Renders a textarea.
 */ function textarea_Textarea(_param) {
    var ariaLabel = _param.ariaLabel, className = _param.className, id = _param.id, onChange = _param.onChange, onInput = _param.onInput, onInvalid = _param.onInvalid, _rows = _param.rows, rows = _rows === void 0 ? 3 : _rows, _size = _param.size, size = _size === void 0 ? "regular" : _size, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "ariaLabel",
        "className",
        "id",
        "onChange",
        "onInput",
        "onInvalid",
        "rows",
        "size"
    ]);
    var ref = (0,react.useState)(false), invalid = ref[0], setInvalid = ref[1];
    var props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        "aria-label": ariaLabel
    });
    if (onChange) {
        props.onChange = function(event) {
            var target = event.target;
            onChange(target.value, event);
        };
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styles/* Wrapper */.im, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, (0,_object_spread/* default */.Z)({
            "data-invalid": invalid,
            id: id,
            onInvalid: function(event) {
                if (onInvalid) {
                    onInvalid(event);
                }
                setInvalid(true);
            },
            onInput: function(event) {
                if (onInput) {
                    onInput(event);
                }
                setInvalid(false);
            },
            rows: rows,
            size: size
        }, props))
    });
};
textarea_Textarea.propTypes = {
    /**
   * ARIA label.
   */ ariaLabel: (prop_types_default()).string,
    /**
   * Textarea class name.
   */ className: (prop_types_default()).string,
    /**
   * Default value. Use for uncontrolled textareas.
   */ defaultValue: (prop_types_default()).string,
    /**
   * Whether to disable the textarea.
   */ disabled: (prop_types_default()).bool,
    /**
   * Textarea ID. If not provided, ID will be automatically generated.
   */ id: (prop_types_default()).string,
    /**
   * Textarea name.
   */ name: (prop_types_default()).string.isRequired,
    /**
   * Function called on change. Will be called with two attributes: `value` and `event`.
   */ onChange: (prop_types_default()).func,
    /**
   * Function called on input. Will be called with one attribute: `event`.
   */ onInput: (prop_types_default()).func,
    /**
   * Function called on invalid. Will be called with one attribute: `event`.
   */ onInvalid: (prop_types_default()).func,
    /**
   * Textarea placeholder.
   */ placeholder: (prop_types_default()).string,
    /**
   * Whether the textarea should be required.
   */ required: (prop_types_default()).bool,
    /**
   * Number of rows to render.
   */ rows: (prop_types_default()).number,
    /**
   * Textarea size.
   */ size: prop_types_default().oneOf([
        "regular",
        "small"
    ]),
    /**
   * Value. Use for controlled textareas along with `onChange`.
   */ value: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/textarea_field/index.jsx







/**
 * Renders a textarea field.
 */ function TextareaField(_param) {
    var className = _param.className, hideOptional = _param.hideOptional, hint = _param.hint, id = _param.id, label = _param.label, _rows = _param.rows, rows = _rows === void 0 ? 3 : _rows, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "hideOptional",
        "hint",
        "id",
        "label",
        "rows"
    ]);
    var idWithDefault = (0,reach_auto_id_esm/* useId */.M)(id);
    var disabled = otherProps.disabled, required = otherProps.required, type = otherProps.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, {
        className: className,
        disabled: disabled,
        hideOptional: hideOptional,
        hint: hint,
        id: idWithDefault,
        label: label,
        required: required,
        type: type,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_Textarea, (0,_object_spread/* default */.Z)({
            id: idWithDefault,
            rows: rows
        }, otherProps))
    });
};
TextareaField.propTypes = {
    /**
   * ARIA label.
   */ ariaLabel: (prop_types_default()).string,
    /**
   * Field class name.
   */ className: (prop_types_default()).string,
    /**
   * Default value. Use for uncontrolled textareas.
   */ defaultValue: (prop_types_default()).string,
    /**
   * Whether to disable the textarea.
   */ disabled: (prop_types_default()).bool,
    /**
   * Whether to hide "Optional" label despite field not being required.
   */ hideOptional: (prop_types_default()).bool,
    /**
   * Textarea hint. Displayed below the textarea.
   */ hint: (prop_types_default()).node,
    /**
   * Textarea ID. If not provided, ID will be automatically generated.
   */ id: (prop_types_default()).string,
    /**
   * Textarea label. Displayed above the textarea.
   */ label: (prop_types_default()).node,
    /**
   * Textarea name.
   */ name: (prop_types_default()).string.isRequired,
    /**
   * Function called on change. Will be called with two attributes: `value` and `event`.
   */ onChange: (prop_types_default()).func,
    /**
   * Textarea placeholder.
   */ placeholder: (prop_types_default()).string,
    /**
   * Whether the textarea should be required.
   */ required: (prop_types_default()).bool,
    /**
   * Number of rows to render.
   */ rows: (prop_types_default()).number,
    /**
   * Textarea size.
   */ size: prop_types_default().oneOf([
        "regular",
        "small"
    ]),
    /**
   * Value. Use for controlled textareas along with `onChange`.
   */ value: (prop_types_default()).string
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,8278,9440,5943,8229,7467,8338,9774,2888,179], function() { return __webpack_exec__(42903); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);